import {ReactNode} from 'react'
import cn from 'clsx'
// import {Tabs} from 'antd'
import { Tabs } from '../V2'

import './ListTabsPanel.scss'
import {useRouteTabs} from 'common/hooks'
import {Tab} from 'common/types'

interface ListTabsPanelProps {
  className?: string
  noGap?: boolean
  path: string
  tabs: Tab[]
  action?: ReactNode
}

export default function ListTabsPanel({
  className,
  noGap,
  path,
  tabs,
  action,
}: ListTabsPanelProps) {
  const [activeTab, handleTabsChange] = useRouteTabs(path)

  return (
    <div
      className={cn(
        className,
        'ListTabsPanel',
        action && !noGap && 'ListTabsPanel_action'
      )}
      style={{
        paddingBottom: '64px',
        borderBottom: '1px solid grey'
      }}
    >
      <Tabs
        activeKey={activeTab}
        items={tabs}
        onChange={handleTabsChange}
      />
      {action}
    </div>
  )
}
